import { gql } from '@apollo/client';

const DUPLICATE_ORDER = gql`
  mutation DuplicateOrder($orderNodeId: ID!) {
    duplicateOrderAsDraft(orderNodeId: $orderNodeId) {
      order {
        id
      }
    }
  }
`;

export default DUPLICATE_ORDER;
